import { apiFetch } from './api';

export interface CreatePaymentIntentParams {
  amount: number;
  currency?: string;
  orderId?: string;
  bookingId?: string;
  metadata?: Record<string, string>;
}

export interface PaymentIntentResult {
  clientSecret: string;
  paymentIntentId: string;
}

export const createPaymentIntent = async (
  params: CreatePaymentIntentParams,
): Promise<PaymentIntentResult> => {
  const res = await apiFetch<{ success: boolean; data: PaymentIntentResult }>(
    '/v1/payments/create-intent',
    { method: 'POST', body: params },
  );
  return res.data;
};

export const confirmPayment = async (
  paymentId: string,
  params?: { paymentMethodId?: string },
): Promise<{ status: string }> => {
  const res = await apiFetch<{ success: boolean; data: { status: string } }>(
    `/v1/payments/${paymentId}/confirm`,
    { method: 'POST', body: params },
  );
  return res.data;
};
